export default "__VITE_ASSET__q3SFs_1$__"